import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  tagList: [],
  tagFormList: [],
  tagDetail: [],
  loading: false,
  error: undefined,
  success: false,
  actionType: null,
};

const tagSlice = createSlice({
  name: "tag",
  initialState,
  reducers: {
    clearError(state) {
      state.loading = false;
      state.success = false;
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
      state.actionType = null;
    },
    actionSuccess(state, action) {
      state.success = true;
      state.loading = false;
      state.actionType = action.payload || null;
    },
    fetchTagList(state, action) {
      state.tagList = action.payload;
      state.loading = false;
    },
    fetchTagFormList(state, action) {
      state.tagFormList = action.payload;
      state.loading = false;
    },
    fetchTagDetail(state, action) {
      state.tagDetail = action.payload;
      state.loading = false;
    },
  },
});

export const tagActions = tagSlice.actions;

export default tagSlice.reducer;
